import { Container, Grid } from '@mui/material';
import React, {useEffect } from 'react';
import { formatDollars } from '../../../../common';
import CardComponent from '../../../../common/components/CardComponent';
import { theme } from '../../../../themes';
import { Props } from '../container';
import { useDispatch} from 'react-redux';
import { AssociationsTable } from './AssociationsTable';
import { fetchAfslAndModelAssociations } from '../store/thunks';

export const AssociationsComponent = ({
  loadingProgress,
  strategyAssociations,
  selectStrategyComposition,
}: Props): JSX.Element => {

  const dispatch = useDispatch();

  useEffect(() => {
    const strategyVersionId = selectStrategyComposition?.strategyVersionId ?? null;

    if (!selectStrategyComposition) return;
      dispatch(
          fetchAfslAndModelAssociations({
            strategyId: selectStrategyComposition.strategyId,
            strategyVersionId
          })
      );
  }, [selectStrategyComposition?.strategyId, selectStrategyComposition?.strategyVersionId,  dispatch]);

  return (
    <Container style={{ paddingTop: '20px', paddingBottom: '20px' }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <CardComponent
            progress={loadingProgress}
            background={theme.palette.gradient1?.main}
            value={formatDollars(strategyAssociations?.fua)}
            subText={'FUA'}
          />
        </Grid>
        <Grid item xs={6}>
          <CardComponent
            progress={loadingProgress}
            background={theme.palette.gradient2?.main}
            value={strategyAssociations?.portfolioCount}
            subText={'Portfolios'}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: '24px' }}>
        <Grid item xs={12}>
          {!!strategyAssociations && !!strategyAssociations.portfolioExposures && (
            <AssociationsTable progress={loadingProgress} data={strategyAssociations?.portfolioExposures} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
